// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_CriarAcessoPortalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /clientes/criar-acesso-portal
 *
 * The portal's provisioning payload, projected onto a shape this platform
 * owns rather than passed through. Field names are English per ADR-0014 §3.
 */
import type { Clientes_CriarAcessoPortalCredencialRow } from './Clientes_CriarAcessoPortalCredencialRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_CriarAcessoPortalResponseDados {
cliente_id: number
document: string
already_existed: boolean
portal_user_id?: string
status?: string
created_at?: string
activation_credential?: Clientes_CriarAcessoPortalCredencialRow
}

export type Clientes_CriarAcessoPortalResponse = ApiResponse<Clientes_CriarAcessoPortalResponseDados>;

registerResponseContract('Clientes_CriarAcessoPortalResponse', {
  cliente_id:      { type: 'number',  required: true },
  document:        { type: 'string',  required: true },
  already_existed: { type: 'boolean', required: true },
  portal_user_id:  { type: 'string',  required: false },
  status:          { type: 'string',  required: false },
  created_at:      { type: 'string',  required: false },
  activation_credential: {
    type: 'object',
    required: false,
    fields: {
      value:      { type: 'string',  required: false },
      expires_at: { type: 'string',  required: false },
      rule:       { type: 'string',  required: false },
    },
  },
})
